"use client";
import React from "react";
import useTranslations from "@/i18n/useTranslations";

type Props = {
  optIn: boolean;
  toggleMarketingOptIn: () => void;
  containerClassName?: string;
};

export default function MarketingOptIn({
  optIn,
  toggleMarketingOptIn,
  containerClassName,
}: Readonly<Props>) {
  const t = useTranslations("Common");
  return (
    <div className={containerClassName}>
      <label className="flex items-start text-gray-700 cursor-pointer text-base">
        <input
          type="checkbox"
          name="marketing_consent"
          checked={optIn}
          onChange={toggleMarketingOptIn}
          className="mr-2 h-5 w-5 text-primary-500 border-2 border-primary-500 focus:ring-primary-500 focus:ring-2"
        />
        <span>{t("marketingOptIn")}</span>
      </label>
    </div>
  );
}
